import React from "react";
import loader from "./loader";
import InternalPageRenderer from "./page-renderer";
const ProdPageRenderer = _ref => {
  let {
    location
  } = _ref;
  const pageResources = loader.loadPageSync(location.pathname);
  if (!pageResources) {
    return null;
  }
  return /*#__PURE__*/React.createElement(InternalPageRenderer, {
    location,
    pageResources,
    ...pageResources.json
  });
};
export default ProdPageRenderer;